module.exports = __webpack_public_path__ + "media/images/riders/small/KATE_CURD-5a9439e61bb5c2ba47573b8b1a54c39a.png";